import React from "react";
import { Router as BaseRouter, StaticRouter } from "react-router-dom";

import { createBrowserHistory, createMemoryHistory } from "history";

import { onBrowser } from "@kazoohr/helpers";

export interface IRouterProps {
  route?: string;
}

export function Router({
  children,
  route = "/",
}: React.PropsWithChildren<IRouterProps>) {
  if (process.env.NODE_ENV === "test") {
    return (
      <BaseRouter
        history={createMemoryHistory({
          initialEntries: [route],
        })}
      >
        {children}
      </BaseRouter>
    );
  }

  if (!onBrowser()) {
    return <StaticRouter location={route}>{children}</StaticRouter>;
  }

  /**
   * For interop between the old bundle strategy and the experimental one, we
   * only need one router context, or we can't do SPA-style routing between
   * applications. This prevents us from doing that by making sure we only ever
   * attach a single router per page.
   */
  if (window.kazoo.routerAttached) {
    return <>{children}</>;
  }

  window.kazoo.routerAttached = true;

  return <BaseRouter history={createBrowserHistory()}>{children}</BaseRouter>;
}
